export const removeNulls = <T>(object: Record<string, T>) =>
  Object.entries(object).reduce((acc, [key, value]) => {
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, T>);

export const countTrueValues = <T extends Record<string, unknown>>(
  obj: T,
  excludeKeys: (keyof T | string)[] = [],
): number => {
  const normalized = Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, Boolean(value)]),
  ) as Record<string, boolean>;

  return Object.entries(normalized)
    .filter(([key, value]) => value && !excludeKeys.includes(key))
    .length;
};
